import { COLOR_THEMES, ColorThemeType } from '@qlevr/shared/constants';

export function isThemeType(obj: any): obj is ColorThemeType {
  return Object.values(COLOR_THEMES).includes(obj);
}
